import { createReducer, ActionType } from 'typesafe-actions';
import {
  saveRoundBetSuccessAction,
  repeatBetSuccessAction,
  clearRepeatBetAction,
  resetRepeatBetAction,
} from './actions';
import { IBetRepeatState } from './types';

export const betRepeatState: IBetRepeatState = {
  isUsed: false,
  value: null,
};

const actions = {
  saveRoundBetSuccessAction,
  repeatBetSuccessAction,
  clearRepeatBetAction,
  resetRepeatBetAction,
};

export const betRepeatReducer = createReducer<IBetRepeatState, ActionType<typeof actions>>(
  betRepeatState,
)
  .handleAction(saveRoundBetSuccessAction, (state, { payload }) => ({
    ...state,
    value: payload,
  }))
  .handleAction(repeatBetSuccessAction, (state) => ({
    ...state,
    isUsed: true,
  }))
  .handleAction(clearRepeatBetAction, (state) => ({
    ...state,
    isUsed: false,
  }))
  .handleAction(resetRepeatBetAction, (state) => ({
    ...state,
    isUsed: false,
  }));
